import { useEffect, useMemo, useState } from 'react';
import { getActiveSectionsWithData } from '../utils';
import useDebouncedFetchSection from './useDebouncedFetchSections';
import useFetchRecommendationPod from './useFetchRecommendationPod';
export default function useSections(query, cioClient, sections, zeroStateSections, advancedParameters) {
    const zeroStateActiveSections = !query.length && zeroStateSections;
    const [activeSections, setActiveSections] = useState(zeroStateActiveSections ? zeroStateSections : sections);
    const autocompleteSections = useMemo(() => activeSections?.filter((config) => config.type === 'autocomplete' || !config.type), [activeSections]);
    const recommendationsSections = activeSections?.filter((config) => config.type === 'recommendations');
    // Fetch Autocomplete Results
    const autocompleteResults = useDebouncedFetchSection(query, cioClient, autocompleteSections, advancedParameters);
    // Fetch Recommendations Results
    const recommendationsResults = useFetchRecommendationPod(cioClient, recommendationsSections);
    const sectionResults = { ...autocompleteResults, ...recommendationsResults };
    const activeSectionsWithData = getActiveSectionsWithData(activeSections, sectionResults);
    useEffect(() => {
        setActiveSections(zeroStateActiveSections ? zeroStateSections : sections);
    }, [query, sections, zeroStateSections, zeroStateActiveSections]);
    useEffect(() => {
        if (sections && !Array.isArray(sections)) {
            setActiveSections([]);
        }
        if (zeroStateSections && !Array.isArray(zeroStateSections)) {
            setActiveSections([]);
        }
    }, [sections, zeroStateSections]);
    return {
        activeSections,
        activeSectionsWithData,
        zeroStateActiveSections,
    };
}
